import { Injectable } from '@angular/core';
import { UtilsService } from './utils.service';
import { AppConstants } from "../app.constants";
import { SharedService } from './shared.service';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UsuarioService } from './usuario.service';

@Injectable({
  providedIn: 'root'
})
export class SesionService {

  APP_MENUS: any[] = AppConstants.MENUS;
  APP_SUBMENUS: any[] = AppConstants.SUBMENUS;
  menus: any[] = [];
  subMenus: any[] = [];
  keySelected: string = '';

  constructor(private http: HttpClient, private utilsService: UtilsService, private sharedService: SharedService, private usuarioService: UsuarioService) { }

  validarSesion(): Boolean {
    let sesion = this.utilsService.getLocalStorage('sesion', true);
    let sesionDecodificada = this.utilsService.validarObjeto(sesion) ? this.utilsService.decodificar(sesion, true) : null;
    if (this.utilsService.validarObjeto(sesionDecodificada) && this.utilsService.validarString(sesionDecodificada.codigoVerificacion)) {
      this.obtenerSideBar(sesionDecodificada.rol);
      this.sharedService.setUserData(sesionDecodificada);
      return true;
    } else {
      return false;
    }
  }

  getSesionData(): any {
    let sesion = this.utilsService.getLocalStorage('sesion', true);
    if (this.utilsService.validarObjeto(sesion)) {
      return this.utilsService.decodificar(sesion, true);
    } else {
      return {};
    }
  }

  setSesionData(data: any): any {
    let codificado = this.utilsService.codificar(data, true);
    this.utilsService.setLocalStorage('sesion', codificado, true);
    this.sharedService.setUserData(data);
  }


  login(usuario) {
    let credenciales = {
      usuario: usuario.usuario,
      contrasena: usuario.contrasena
    };
    return this.usuarioService.autentica(credenciales);
  }

  // login(usuario) {
  //   usuario = {
  //     id: 1,
  //     username: usuario.username,
  //     password: btoa(usuario.password),
  //     name: 'Administrador',
  //     lastname: '',
  //     motherlastname: '',
  //     phone: '1234567890',
  //     code: ''
  //   };
  //   return of(usuario);
  // }

  verifyAccess(usuarioCodigo) {
    let credenciales = {
      usuario: usuarioCodigo.usuario,
      codigoVerificacion: usuarioCodigo.codigoVerificacion
    };
    return this.usuarioService.verificaCodigo(credenciales);
  }

  obtenerSideBar(rol?) {
    this.menus = [];
    let tieneRol = this.utilsService.validarString(rol);
    rol = tieneRol ? rol : '';
    this.APP_MENUS.map((menu) => {
      let rolesMenu = menu.roles.split(',');
      let tieneMismoRolMenu = rolesMenu.includes(rol);
      if (tieneMismoRolMenu) {
        this.APP_SUBMENUS.map((submenu) => {
          if (submenu.ruta !== AppConstants.APLICATION_SUBMODULES.VOTACIONES_EMITIR_VOTO.ruta
            && submenu.ruta !== AppConstants.APLICATION_SUBMODULES.VOTACIONES_VER_RESULTADOS.ruta
            && submenu.ruta !== AppConstants.APLICATION_SUBMODULES.VOTACIONES_VER_DATOS_VOTACION.ruta
            && submenu.menu.ruta !== AppConstants.APLICATION_MODULES.ERROR.ruta) {
            if (submenu.menu.clave === menu.clave) {
              let rolesSubmenu = submenu.roles.split(',');
              let tieneMismoRolSubmenu = rolesSubmenu.includes(rol);
              if (tieneMismoRolSubmenu) {
                this.subMenus.push(this.crearSubmenu(submenu));
              }
            }
          }
        });
        if (this.subMenus.length > 0) {
          this.menus.push(this.crearMenu(menu, this.subMenus));
        }
      }
      this.subMenus = [];
    });
  }

  crearMenu(menu, submenus) {
    let result = {
      key: menu.clave,
      name: menu.nombre,
      icon: menu.icono,
      path: this.utilsService.getString(menu.ruta, true, '/'),
      subitems: submenus
    };
    return result;
  }

  crearSubmenu(submenu) {
    let result = {
      key: submenu.menu.clave,
      name: submenu.nombre,
      icon: submenu.menu.icono,
      path: this.utilsService.getString(submenu.menu.ruta, true, '/') + this.utilsService.getString(submenu.ruta, true, '/', false),
    };
    return result;
  }

}
